@if (payload) {
  <div class="notification-container">
    <div class="message-container">
      @if (payload.data && payload.data.message && payload.data.message.author) {
        <div class="author">
          <img [src]="payload.data.message.author.photo" />
        </div>
      }
      <div class="text">
        <strong>{{ payload.notification.title }}</strong>
        <br />
        {{ payload.notification.body }}
      </div>
      @if (hasAction) {
        <div class="m-l-10">
          <span class="small-btn" (click)="doAction()">View</span>
        </div>
      }
    </div>
  </div>
}
